import React from "react";
import { useDispatch } from "react-redux";
import {
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import FabButton from "@icarius-common/fabButton";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import RatingDetail from "./ratingDetail";
import { createRatingScalesAction, modifyRatingScalesAction } from "../../actions";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import useHandleForm from "./useHandleForm";

const gridStyle = { height: 75, padding: "0px 10px" };

const Form = (props) => {

  const {
    data,
    isCreate,
    ratingScaleNames,
    typeList,
    targetList,
    ratingScaleCodes,
    closeRatingScale,
  } = props;

  const dispatch = useDispatch();

  const createRatingScale = (dataToSend) => {
    dispatch(createRatingScalesAction(dataToSend))
      .then((res) => res?.status === 200 && closeRatingScale());
  }

  const modifyRatingScale = (dataToSend) => {
    dispatch(modifyRatingScalesAction(dataToSend))
      .then((res) => res?.status === 200 && closeRatingScale());
  }

  const openValidationError = (error) => {
    let msg = getLocalizedString("ratingScaleFieldsRequiredAndOptions");
    if (error) {
      msg = error;
    }
    dispatch(openSnackbarAction({ msg, severity: "error", duration: 10000 }));
  }

  const openNameValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("scaleTypeWithEnteredNameAlreadyExists"), severity: "error" }));
  }

  const openCodeValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("scaleTypeWithEnteredCodeAlreadyExists"), severity: "error" }));
  }

  const invalidDetailsNamesCallback = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("cannotHaveRatingsWithSameName"), severity: "error" }));
  }

  const {
    formData,
    setFormValue,
    createItem,
    deleteItem,
    modifyItem,
    submit,
  } = useHandleForm(data, createRatingScale, modifyRatingScale, openValidationError, openNameValidationError, ratingScaleNames, ratingScaleCodes, openCodeValidationError, invalidDetailsNamesCallback);

  const inUse = data?.inUse;

  return (
    <>
      <Grid container item xs={12} direction="row" style={{ paddingTop: 10 }}>
        <Grid container item xs={12}>
          <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
            <TextField
              disabled={!isCreate}
              required
              fullWidth
              margin={"none"}
              label={getLocalizedString("scaleTypeCode")}
              value={formData.code}
              onChange={(e) => setFormValue(e.target.value, "code")}
              inputProps={{ maxLength: 8 }}
            />
          </Grid>
          <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
            <TextField
              required
              fullWidth
              margin={"none"}
              label={getLocalizedString("scaleTypeName")}
              value={formData.name}
              onChange={(e) => setFormValue(e.target.value, "name")}
              inputProps={{ maxLength: 60 }}
            />
          </Grid>
          <Grid container item alignItems="center" xs={12} md={4} style={gridStyle}>
            <FormControl style={{ width: "100%" }}>
              <InputLabel required id={`label`}>{getLocalizedString("calificationToUse")}</InputLabel>
              <Select
                value={formData.type}
                labelId={`label`}
                id={`select`}
                onChange={(e) => setFormValue(e.target.value, "type")}
                margin={"none"}
              >
                {
                  typeList?.map(item => (
                    <MenuItem
                      className={"whiteText"}
                      key={item.key}
                      value={item.key}>
                      {item.value}
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container item xs={12}>
          {
            formData.details?.map((item, index) =>
              <RatingDetail
                inUse={inUse}
                key={index}
                index={index}
                data={item}
                deleteItem={deleteItem}
                modifyItem={modifyItem}
                formData={formData}
                targetList={targetList}
              />
            )
          }
        </Grid>
        <Grid container item xs={12} justify={!inUse ? "space-between" : "flex-end"} alignItems="center" style={{ paddingBottom: 20 }}>
          {!inUse && <FabButton onClick={createItem} title={getLocalizedString("newRatingScaleQuestion")} />}
          <ButtonDialogAction isAccept onClick={submit} text={getLocalizedString("save")} />
        </Grid>
      </Grid>
    </>
  );
}

export default Form;
